import schema from "./schema.json";
import lifecycles from "./lifecycles";

export default {
  schema,
  lifecycles
};
